import { storage } from '../utils/helpers.js';

export default function themeNavigation(themeData) {
  const defaultMenuClass = 'main-menu';
  const subthemeBodyClass = storage.getItem('subThemeName');

  // Find the li.group element in the nav that matches the theme name
  function hideNavigationGroup() {
    $('#mainNavigation .group').each(function () {
      const groupItem = $(this);
      const title = groupItem.children().first().text().trim();

      const matchingTheme = themeData.find((theme) =>
        title.toLowerCase().includes(theme.navItemName.toLowerCase()),
      );

      if (matchingTheme?.classBody === subthemeBodyClass) {
        groupItem.addClass(matchingTheme.classBody + '-menu');
      } else {
        groupItem.addClass(defaultMenuClass);
        if (matchingTheme) groupItem.hide();
      }
    });
  }
  // Apply the navigation structure for the current theme if its class exists on the body
  function applySubthemeNavigation() {
    if (!$('body').hasClass(subthemeBodyClass)) return;

    const subtheme = themeData.find((theme) => theme.classBody === subthemeBodyClass);

    if (subtheme) {
      $(`.${defaultMenuClass}`).remove();
      $(`.${subthemeBodyClass}-menu`).each(function () {
        createMenu($(this));
      });
    }
  }

  hideNavigationGroup();
  applySubthemeNavigation();
}

// Create the menu structure
function createMenu($menu) {
  const $nav = $menu.closest('nav');
  const $groups = $menu.find('.items').first();
  const $mainNavigationUL = $nav.find('ul.groups');

  $mainNavigationUL.last().after($groups);
  $mainNavigationUL.remove();
  createFirstLevel($groups);
}

// firstLevel replace the class 'items' with 'groups' to create the outer dropdown
function createFirstLevel($menu) {
  $menu.removeClass('items').addClass('groups');
  const $firstLevelList = $menu.children();
  $firstLevelList.first().remove();
  $firstLevelList.each(function () {
    const $group = $(this);
    $group.removeClass('item').addClass('group');
    if ($group.children().length > 1) {
      createSecondLevel($group);
    }
  });
}

// secondLevel replace the class 'subitems' with 'items' to create the inner dropdown
function createSecondLevel($group) {
  const $secondLevelList = $group.children();

  if ($secondLevelList.length > 1) {
    $secondLevelList.each(function () {
      const $item = $(this);
      if ($item.hasClass('subitems')) {
        $item.removeClass('subitems');
        $item.addClass('items');
      }
    });
  }
}
